import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import Auth from './auth';

Vue.config.productionTip = false;

Vue.use(Auth);

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  value = value.toString();
  var idx = value.indexOf("T");
  if (idx > 0) {
    value = value.substring(0, idx);
  }
  var exp = value.split("-");
  return exp[2] + "/" + exp[1] + "/" + exp[0];
});

Vue.filter("formatMoney", function (value) {
  var val = (value / 1).toFixed(2).replace(".", ",");
  return val;
});

Vue.filter("calcAge", function (value) {
  if (!value) return "";
  var today = new Date();
  value = value.toString();
  var idx = value.indexOf("T");
  if (idx > 0) {
    value = value.substring(0, idx);
  }
  var exp = value.split("-");
  var d = parseInt(exp[2]);
  var m = parseInt(exp[1]);
  var y = parseInt(exp[0]);
  var age = today.getFullYear() - y;
  var mon = (today.getMonth() + 1) - m;
  if (mon < 0 || (mon === 0 && today.getDate() < d)) {
    age--;
  }
  return age;
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');